import React, { useEffect, useState } from "react";
import Image from "../../image";
import ShareBtn from "../../shared/shareBtn";
import EyeIcon from "images/icons/eye-icon.inline.svg";
import authorImg from "images/blog/author.png";

const BlogAuthorOverview = ({ post }) => {
  const { title, publishedDate, author, tags, focuses } = post;
  const taglist =
    focuses?.nodes?.map((tag) => ({
      name: tag.name
    })) ??
    focuses?.nodes?.map((tag) => ({
      name: tag.name
    })) ??
    [];

  const blogViews = 0;

  const [shareUrl, setShareUrl] = useState("#");

  useEffect(() => {
    setShareUrl(location?.href);
  }, []);

  const authorName = author?.node?.firstName
    ? [author?.node?.firstName, author?.node?.lastName].join(" ")
    : "";

  const authorAvatar = author?.node?.avatar?.url ?? authorImg;

  return (
    <div className="relative -mb-20">
      <div className="px-4 bg-white sm:px-9 dark:bg-gray-darker">
        <div className="flex justify-between items-center py-4 border-b border-gray-quinary">
          <ul className="flex">
            {taglist &&
              taglist.slice(0, 3).map((tag, idx) => (
                <li
                  key={idx}
                  className={`px-2 border-l-[3px] dark:text-gray-generic text-black-lighter ${
                    idx % 3 === 0
                      ? "border-[#AAEB35]"
                      : idx % 3 === 1
                      ? "border-yellow-lighten"
                      : idx % 3 === 2
                      ? "border-green-tertiary"
                      : "border-green-standard"
                  } `}
                >
                  {tag.name}
                </li>
              ))}
          </ul>
          <ShareBtn url={shareUrl} />
        </div>

        <div className="py-5 overview__content">
          <h1
            className="mt-2 mb-5 font-normal dark:font-bold font-alice dark:text-white text-black-lighter"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          {blogViews > 0 && (
            <div className="flex items-center views-number h-9 w-max">
              <EyeIcon className="fill-black-lighter dark:fill-gray-generic" />
              <span className="pl-2 font-medium dark:text-gray-generic text-black-lighter">{`${blogViews} views`}</span>
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center justify-start px-4 py-4 pr-10 sm:px-9 bg-yellow-lighter dark:sm:bg-gray-dark dark:bg-gray-darkest">
        {authorAvatar && authorName && (
          <div className="mr-3 avatar-img">
            <Image
              imageAlt={`Article by ${authorName} `}
              image={""}
              imageClass="rounded-xl w-[48px] h-[48px]"
              sourceUrl={authorAvatar}
            />
          </div>
        )}

        <div className="flex flex-col justify-center dark:text-gray-darken text-black-lighter">
          {authorName && (
            <p className="text-xl dark:font-light dark:text-white text-black-lighter">
              {authorName}
            </p>
          )}
          <p className="text-xs text-black-lighter dark:text-gray-generic">
            Posted: {publishedDate}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BlogAuthorOverview;
